module.exports = __webpack_public_path__ + "img/search_radar.37319f65.png";